import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-slate-500 flex-wrap" data-testid="breadcrumbs">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={it.to || it.label}>
            {i > 0 && <ChevronRight className="h-3 w-3 text-slate-300" />}
            {last || !it.to ? (
              <span className="text-slate-700 font-medium">{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:text-teal">{it.label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
